import {Directive, ElementRef, EventEmitter, OnInit, Output} from '@angular/core';

@Directive({
    selector: '[appDroppable]',
    standalone: true
})
export class DroppableDirective implements OnInit {
  @Output() dropped: EventEmitter<any> = new EventEmitter();

  constructor(private _elementRef: ElementRef) {
  }

  ngOnInit() {
    const el = this._elementRef.nativeElement;

    document.addEventListener('dragenter', (e: DragEvent) => {

      if (this.containsFile(e)) {
        el.classList.add('over');
        e.dataTransfer.dropEffect = 'move';

        return false;
      }

      return true;
    });

    document.addEventListener('dragend', (e: DragEvent) => {
      console.log('dragend');
      el.classList.remove('over');

      return false;
    });

    document.addEventListener('dragleave', (e: DragEvent) => {
      if (e.x === 0 && e.y === 0) {
        el.classList.remove('over');
      }

      return false;
    });

    el.addEventListener('dragover', (e: DragEvent) => {
      console.log('dragover');
      if (e.preventDefault) {
        e.preventDefault();
      }

      if (this.containsFile(e)) {
        el.classList.add('over');
        e.dataTransfer.dropEffect = 'move';

        return false;
      }
      return true;
    });

    // On drop, get the data and convert it back to a JSON object
    // and fire off an event passing the data
    el.addEventListener('drop', (e: DragEvent) => {
      console.log('drop');
      if (this.containsFile(e)) {
        if (e.stopPropagation) {
          e.stopPropagation(); // Stops some browsers from redirecting.
        }
        if (e.preventDefault) {
          e.preventDefault();
        }

        el.classList.remove('over');
        this.dropped.emit(e);
      }
      document.dispatchEvent(new Event('dragend'));
      return false;
    });
  }

  private containsFile(e: DragEvent): boolean {
    if (!e.dataTransfer) {
      return false;
    }
    const containsItem = !!e.dataTransfer.items && e.dataTransfer.items[0].kind === 'file';
    const containsFile = !!e.dataTransfer.files && !!e.dataTransfer.files[0];

    return containsItem || containsFile;
  }

}
